import Footer from "../common/Footer";
import Header from "../common/Header";
import ServicesPgBackground from "../../Images/services-bg.webp";
// import ForeignBusinessBg from "../../Images/Foreign-Business-Services-Pg.webp";
// import Service2Bg from "../../Images/Market-Research-Services-Pg.webp";
// import Service3Bg from "../../Images/Sector-Specific-Services-Pg.webp";
// import Service4Bg from "../../Images/Govt-Licensing-Services_Pg.webp";
// import Service5Bg from "../../Images/Joint-Ventures-bg-ServicesPg.webp";
// import Service6Bg from "../../Images/Real-Estate-ServicesPg.webp";
// import Service7Bg from "../../Images/financial-sector-services.webp";
// import Service8Bg from "../../Images/venture-capital-services.webp";
// import Service9Bg from "../../Images/business-dev-services.webp";
import Service10Bg from "../../Images/advisory.webp";
import Service11Bg from "../../Images/legal-service.webp";
import Service12Bg from "../../Images/hr-financial-services.webp";
import Service13Bg from "../../Images/investment-oppo-services.webp";
import Service14Bg from "../../Images/innovation-services.webp";
// import Service15Bg from "../../Images/conference-services.webp";



import ServiceCard from "./ServiceCard";
import WhyChooseSemars from "./WhyChooseSemars";
// import WhyChooseImage from "../../Images/(why-choose-semars bg)Services-Pg.png";

const servicesData = [
  // {
  //   id: 1,
  //   title: "Management Consulting",
  //   subtitle: "We provide strategic, operational, and financial consulting for businesses navigating the complexities of the Saudi and GCC economies. From feasibility assessments to restructuring, performance optimization, and digital transformation, we serve as the trusted advisors to CEOs, boards, and government-linked entities.",
  //   backgroundImage: ForeignBusinessBg,
  //   bgColor: "#5B8AC961",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Business Setup Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Company registration and legal structuring</li>
  //         <li>Regulatory compliance guidance</li>
  //         <li>Market entry strategy development</li>
  //         <li>Local partner identification</li>
  //       </ul>
  //       <p>
  //         We provide comprehensive support to establish your business presence
  //         in Saudi Arabia with full regulatory compliance.
  //       </p>
  //     </div>
  //   ),
  // },
  // {
  //   id: 2,
  //   title: "Defense Procurements ",
  //   subtitle:
  //     "With our founder’s former advisory role to Saudi defense leadership, we specialize in sourcing, evaluating, and facilitating international defense procurements. Our services include vendor assessment, compliance coordination, logistics support, and policy-aligned procurement planning within the KSA’s defense modernization objectives.",
  //   backgroundImage: Service2Bg,
  //   bgColor: "#03A58E30",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Research Capabilities:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Industry analysis and trends</li>
  //         <li>Competitor landscape assessment</li>
  //         <li>Consumer behavior insights</li>
  //         <li>Market size and growth potential</li>
  //       </ul>
  //       <p>
  //         Our research team provides actionable insights to help you make
  //         data-driven business decisions.
  //       </p>
  //     </div>
  //   ),
  // },
  // {
  //   id: 3,
  //   title: "Manufacturing & Industrial Solutions",
  //   subtitle:
  //     "Semars Holding supports foreign manufacturers in entering and expanding within the Saudi market. We offer industrial site selection, JV formation, compliance advisory, and access to local supply chains and workforce solutions—aligned with Saudi Arabia’s localization mandates and Vision 2030 industrialization goals.",
  //   backgroundImage: Service3Bg,
  //   bgColor: "#0000003D",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Strategic Sectors:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Energy & Renewable Resources</li>
  //         <li>Technology & Innovation</li>
  //         <li>Healthcare & Life Sciences</li>
  //         <li>Tourism & Entertainment</li>
  //       </ul>
  //       <p>
  //         We provide specialized expertise across Saudi Arabia's priority
  //         sectors, ensuring your investments align with national development
  //         goals.
  //       </p>
  //     </div>
  //   ),
  // },
  // {
  //   id: 4,
  //   title: "Real Estate & Urban Development",
  //   subtitle:
  //     "We provide full-cycle advisory for real estate investments, including land acquisition, commercial development, housing projects, and smart city initiatives. Our team is experienced in navigating municipal zoning, MISA permits, investor protections, and property lifecycle management in cities like Riyadh, Jeddah, and emerging zones like NEOM and Qiddiya",
  //   backgroundImage: Service4Bg,
  //   bgColor: "#233D5D78",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Government Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Licensing and permit acquisition</li>
  //         <li>Government agency liaison</li>
  //         <li>Regulatory compliance management</li>
  //         <li>Public sector engagement</li>
  //       </ul>
  //       <p>
  //         Our government relations team ensures smooth interactions with Saudi
  //         authorities and expedited processing of your business requirements.
  //       </p>
  //     </div>
  //   ),
  // },
  // {
  //   id: 5,
  //   title: "Healthcare & Medical Investment",
  //   subtitle:
  //     "We assist global healthcare providers, hospital groups, medtech, and pharma companies to enter Saudi Arabia’s growing health ecosystem. Our services cover regulatory approvals, partnership formation, hospital management consulting, and alignment with MOH and SFDA guidelines.",
  //   backgroundImage: Service5Bg,
  //   bgColor: "#233D5D78",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Local partner identification and vetting</li>
  //         <li>Joint venture structuring</li>
  //         <li>Partnership agreement negotiation</li>
  //         <li>Ongoing relationship management</li>
  //       </ul>
  //       <p>
  //         We help you build strategic partnerships that drive mutual success and
  //         sustainable growth in the Saudi market.
  //       </p>
  //     </div>
  //   ),
  // },
  // {
  //   id: 6,
  //   title: "Construction & Mega Project Advisory",
  //   subtitle:
  //     "Semars facilitates international participation in giga projects and public-private infrastructure programs in Saudi Arabia. We support tendering, local partnerships, regulatory compliance, risk advisory, and project management consultancy services for roadways, industrial zones, utilities, and real estate megaprojects.",
  //   backgroundImage: Service6Bg,
  //   bgColor: "#FCC9682B",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Real Estate Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Property acquisition and due diligence</li>
  //         <li>Development project management</li>
  //         <li>Investment analysis and valuation</li>
  //         <li>Property management services</li>
  //       </ul>
  //       <p>
  //         Our real estate team provides end-to-end support for residential,
  //         commercial, and industrial property investments in Saudi Arabia's
  //         growing market.
  //       </p>
  //     </div>
  //   ),
  // },

  //  {
  //   id: 7,
  //   title: " Financial Sector Transformation",
  //   subtitle:
  //     "Our consultants help banks, fintech startups, and family offices comply with SAMA regulations, integrate digital platforms, and structure high-value investment products. We offer risk consulting, governance frameworks, and market entry support for international financial institutions. ",
  //   backgroundImage: Service7Bg,
  //   bgColor: "#233D5D78",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Local partner identification and vetting</li>
  //         <li>Joint venture structuring</li>
  //         <li>Partnership agreement negotiation</li>
  //         <li>Ongoing relationship management</li>
  //       </ul>
  //       <p>
  //         We help you build strategic partnerships that drive mutual success and
  //         sustainable growth in the Saudi market.
  //       </p>
  //     </div>
  //   ),
  // },

  //  {
  //   id: 8,
  //   title: "Venture Capital & Private Equity Services",
  //   subtitle:
  //     "We act as advisors and fund managers for venture capital and private equity firms investing in Saudi Arabia. From opportunity scouting to deal structuring, due diligence, and postinvestment strategy, our team ensures high-yield investments in innovation-driven sectors.",
  //   backgroundImage: Service8Bg,
  //   bgColor: "#233D5D78",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Local partner identification and vetting</li>
  //         <li>Joint venture structuring</li>
  //         <li>Partnership agreement negotiation</li>
  //         <li>Ongoing relationship management</li>
  //       </ul>
  //       <p>
  //         We help you build strategic partnerships that drive mutual success and
  //         sustainable growth in the Saudi market.
  //       </p>
  //     </div>
  //   ),
  // },

  //  {
  //   id: 9,
  //   title: " Business Development & Expansion Support (KSA & GCC)",
  //   subtitle:
  //     "We help businesses expand into Saudi Arabia and the GCC through lead generation, sales enablement, government introductions, and B2B facilitation. Our support also includes localization strategies, brand positioning, and channel partner development.",
  //   backgroundImage: Service9Bg,
  //   bgColor: "#233D5D78",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Local partner identification and vetting</li>
  //         <li>Joint venture structuring</li>
  //         <li>Partnership agreement negotiation</li>
  //         <li>Ongoing relationship management</li>
  //       </ul>
  //       <p>
  //         We help you build strategic partnerships that drive mutual success and
  //         sustainable growth in the Saudi market.
  //       </p>
  //     </div>
  //   ),
  // },

   {
    id: 1,
    title: "Market Entry & End-to-End Advisory ",
    subtitle:
      "We deliver complete solutions for market entry, including commercial registration, licensing, tax and legal compliance, and operational planning. From MISA licensing and CR issuance to office setup and staffing, we ensure businesses go live with speed and precision",
    backgroundImage: Service10Bg,
    bgColor: "#233D5D78",
    expandedContent: (
      <div>
        <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
        <ul className="space-y-2 list-disc list-inside mb-4">
          <li>Local partner identification and vetting</li>
          <li>Joint venture structuring</li>
          <li>Partnership agreement negotiation</li>
          <li>Ongoing relationship management</li>
        </ul>
        <p>
          We help you build strategic partnerships that drive mutual success and
          sustainable growth in the Saudi market.
        </p>
      </div>
    ),
  },

   {
    id: 2,
    title: "Legal & Compliance Services ",
    subtitle:
      "Our in-house legal experts and partner firms offer regulatory compliance, corporate law, commercial contracts, labor law, and investment protection services. We ensure that clients meet all obligations under Saudi commercial, tax, labor, and GOSI regulations.",
    backgroundImage: Service11Bg,
    bgColor: "#233D5D78",
    expandedContent: (
      <div>
        <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
        <ul className="space-y-2 list-disc list-inside mb-4">
          <li>Local partner identification and vetting</li>
          <li>Joint venture structuring</li>
          <li>Partnership agreement negotiation</li>
          <li>Ongoing relationship management</li>
        </ul>
        <p>
          We help you build strategic partnerships that drive mutual success and
          sustainable growth in the Saudi market.
        </p>
      </div>
    ),
  },

   {
    id: 12,
    title: "HR & Financial Services",
    subtitle:
      "We support talent strategy, HR outsourcing, payroll structuring, and financial reporting. Our services help businesses stay compliant with Saudi labor law and Saudization policies while optimizing their workforce costs and governance standards",
    backgroundImage: Service12Bg,
    bgColor: "#233D5D78",
    expandedContent: (
      <div>
        <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
        <ul className="space-y-2 list-disc list-inside mb-4">
          <li>Local partner identification and vetting</li>
          <li>Joint venture structuring</li>
          <li>Partnership agreement negotiation</li>
          <li>Ongoing relationship management</li>
        </ul>
        <p>
          We help you build strategic partnerships that drive mutual success and
          sustainable growth in the Saudi market.
        </p>
      </div>
    ),
  },

   {
    id: 13,
    title: "Investment Opportunities & Portfolio Management",
    subtitle:
      "Semars provides curated investment opportunities in high-growth sectors including real estate, logistics, ICT, and healthcare. We also offer family offices and institutional investors full portfolio management, risk mitigation, and asset optimization.",
    backgroundImage: Service13Bg,
    bgColor: "#233D5D78",
    expandedContent: (
      <div>
        <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
        <ul className="space-y-2 list-disc list-inside mb-4">
          <li>Local partner identification and vetting</li>
          <li>Joint venture structuring</li>
          <li>Partnership agreement negotiation</li>
          <li>Ongoing relationship management</li>
        </ul>
        <p>
          We help you build strategic partnerships that drive mutual success and
          sustainable growth in the Saudi market.
        </p>
      </div>
    ),
  },

   {
    id: 14,
    title: "R&D Support & Innovation Enablement ",
    subtitle:
      "We enable companies to establish research and development operations inside the Kingdom. Our focus areas include AI, machine learning, data science, big data, cloud computing, cybersecurity, blockchain, and climate technologies including carbon credits. We also support the development of intellectual property, patent filing, and commercialization of Saudi-based innovations. In alignment with the Kingdom’s push for localization, we facilitate semiconductor chip design and fabrication, robotics, autonomous vehicles, and robotaxi solutions. We connect clients with public-private R&D incentives and establish pathways for technology transfer and sovereign IP creation. ",
    backgroundImage: Service14Bg,
    bgColor: "#233D5D78",
    expandedContent: (
      <div>
        <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
        <ul className="space-y-2 list-disc list-inside mb-4">
          <li>Local partner identification and vetting</li>
          <li>Joint venture structuring</li>
          <li>Partnership agreement negotiation</li>
          <li>Ongoing relationship management</li>
        </ul>
        <p>
          We help you build strategic partnerships that drive mutual success and
          sustainable growth in the Saudi market.
        </p>
      </div>
    ),
  },

  //  {
  //   id: 15,
  //   title: " Events & Conference Management",
  //   subtitle:
  //     "We conceptualize and organize bespoke conferences, investor roadshows, and public private forums to strengthen business visibility, diplomatic relations, and market engagement in Saudi Arabia. Our team manages event content, logistics, protocol, and media. ",
  //   backgroundImage: Service15Bg,
  //   bgColor: "#233D5D78",
  //   expandedContent: (
  //     <div>
  //       <h4 className="text-xl font-semibold mb-4">Partnership Services:</h4>
  //       <ul className="space-y-2 list-disc list-inside mb-4">
  //         <li>Local partner identification and vetting</li>
  //         <li>Joint venture structuring</li>
  //         <li>Partnership agreement negotiation</li>
  //         <li>Ongoing relationship management</li>
  //       </ul>
  //       <p>
  //         We help you build strategic partnerships that drive mutual success and
  //         sustainable growth in the Saudi market.
  //       </p>
  //     </div>
  //   ),
  // },

  
];

const ServicesPage = () => {
  return (
    <div>
      <Header />
      <div className="relative min-h-screen bg-black">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `url(${ServicesPgBackground})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPositionY: "10%",
          }}
        ></div>
        <section className="relative py-10 px-6 pb-20">
          <section className="relative w-full py-16 text-white">
            <div className="pt-20" data-aos="fade-up">
              <div className="text-center mb-12 max-w-7xl mx-auto px-6">
                <h2 className="text-5xl md:text-6xl font-semibold">
                  Our Services
                </h2>
                <p className="text-xl py-8 max-w-3xl mx-auto">
                  Semars Holding offers an integrated portfolio of high-impact services designed to facilitate 
                  business excellence, investment success, and sustainable expansion in Saudi Arabia and the 
                  broader GCC region. Each service area is shaped by our deep market knowledge, 
                  institutional connections, and the strategic foresight of our founder, Mr. Sabeel Sajid. 
                </p>
                <h3 className="text-2xl md:text-3xl font-semibold text-[#C99C48] mb-8">
                  Comprehensive Business Advisory – From Market Entry to Expansion
                </h3>
              </div>
            </div>
          </section>

          <div className="relative z-10 max-w-4xl mx-auto space-y-28">
            {servicesData.map((service, index) => (
              <div
                key={service.id}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <ServiceCard {...service} />
              </div>
            ))}
          </div>
          {/* Why Choose Semars Section */}
        </section>
        <WhyChooseSemars
          backgroundImage={WhyChooseSemars} // Replace with your actual image: WhyChooseImage
        />
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
